// Protege componentes según permisos específicos (create, edit, delete, etc.).
// Verifica que el usuario tenga los permisos requeridos y redirige si no los cumple.

// frontend/src/components/auth/PermissionGuard.js

import { useAuth } from '../../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

export const PermissionGuard = ({ 
    children, 
    permissions = [], 
    roles = [], 
    requireAllPermissions = false 
}) => {
    const { 
        hasPermissions, 
        hasPermission,   // 👈 agregalo acá
        hasRole, 
        loading, 
        user, 
        isSuperAdmin 
      } = useAuth();
    
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-10 w-10 border-2 border-custom-brand"></div>
            </div>
        );
    }

    // Verificar autenticación
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Super admin siempre tiene acceso
    if (isSuperAdmin) {
        return children;
    }

    // Verificar roles si se especificaron
    if (roles.length > 0 && !roles.some(role => hasRole(role))) {
        return <Navigate to="/unauthorized" replace />;
    }

    // Verificar permisos
    if (permissions.length > 0) {
        const hasRequiredPermissions = requireAllPermissions
    ? hasPermissions(permissions)
    : permissions.some(permission => hasPermission(permission));

        if (!hasRequiredPermissions) {
            return <Navigate to="/unauthorized" replace />;
        }
    }

    return children;
};

// HOC para usar PermissionGuard como decorador
export const withPermissions = (
    WrappedComponent, 
    { permissions = [], roles = [], requireAllPermissions = false }
) => {
    return (props) => (
        <PermissionGuard 
            permissions={permissions} 
            roles={roles}
            requireAllPermissions={requireAllPermissions}
        >
            <WrappedComponent {...props} />
        </PermissionGuard>
    );
};

export default PermissionGuard;